import {
    getAttendanceDeviceData,
    getAttendanceDeviceUuid,
    getAttendancePlatform
} from "./attendance-device-helper";
import {
    calculateAttendanceQrFrameBounds,
    getAttendanceQrFrameBounds
} from "./attendance-qr-frame-helper";


const AttendanceHelpers = {
    getDeviceData: getAttendanceDeviceData,
    getDeviceUuid: getAttendanceDeviceUuid,
    getPlatform: getAttendancePlatform,
    getQrFrameBounds: getAttendanceQrFrameBounds
};

export {
    getAttendanceDeviceData,
    getAttendanceDeviceUuid,
    getAttendancePlatform,
    calculateAttendanceQrFrameBounds,
    getAttendanceQrFrameBounds
};

export default AttendanceHelpers;
